import * as React from "react";
import type { SVGProps } from "react";
const SvgRepeat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M3.25 5.5v4.25H7.5M19.94 14.25c-.98 3.46-4.16 6-7.94 6-4.56 0-8.25-3.69-8.25-8.25M12 3.75c4.56 0 8.25 3.69 8.25 8.25"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M4.14 9.5A8.25 8.25 0 0 1 12 3.75M20.75 18.5v-4.25H16.5"
    />
  </svg>
);
export default SvgRepeat;
